<template>
    <div class="preview-page">
        <loadings v-if="loading"></loadings>
        <template v-else>
            <div class='herder'>
                <span class='back'
                      @click="clickBack"><i></i></span>
                <p>预览</p>
            </div>
            <div class="main">
                <div class="item"
                     v-if="review.length">
                    <div class="title">{{unit_name}} {{sid==21?'数学':'语文'}}复习巩固</div>
                    <ul class="clearfix">
                        <li v-for="(item,index) in review"
                            @click="previewPaper(item)"
                            :key="index"><span class="paper-name">第{{item.sequence}}套</span></li>
                    </ul>
                </div>
                <div class="item"
                     v-if="preview.length">
                    <div class="title">{{unit_name}} {{sid==21?'数学':'语文'}}新课预习</div>
                    <ul class="clearfix">
                        <li v-for="(item,index) in preview"
                            @click="reviewPaper(item)"
                            :key="index"><span class="paper-name">第{{item.sequence}}套</span></li>
                    </ul>
                </div>
            </div>
            <noResouse text="暂无积分明细"
                       v-if="false"></noResouse>
        </template>
    </div>
</template>

<script>
import loadings from "COMPONENTS/base/loadingS.vue";
import noResouse from "COMPONENTS/noResouse.vue";
export default {
    components: {
        loadings, noResouse
    },
    data () {
        return {
            loading: false,
            //sid
            sid: this.$route.params.sid,
            //unit_class_id
            unit_class_id: this.$route.params.unit_class_id,
            //unit_name
            unit_name: decodeURIComponent(this.$route.query.unit_name),
            //复习巩固
            preview: [],
            //新课预习
            review: []
        }
    },
    created () {
        this.getPreviewList()
    },
    methods: {
        clickBack () {
            this.$router.go(-1);
        },
        //获取预览列表
        getPreviewList () {
            let url = API_URL_HD_API + '/winter2023/tea/preview_list'
            let params = {
                sid: this.sid,
                unit_class_id: this.unit_class_id
            }
            this.$http.post(url, params).then(res => {
                if (res.data.response === 'ok') {
                    this.preview = res.data.data.preview
                    this.review = res.data.data.review
                }
            })
        },
        //复习巩固预览试卷
        previewPaper (item) {
            let url = ''
            if (this.sid == 21) {
                url = `/preview/task/21/${item.paper_id}/2023winter`
            } else {
                url = `/chinese/inspect/preview/task/${item.paper_id}/2023winter`
            }
            this.$router.push(url)
        },
        //新课预习预览
        reviewPaper (item) {
            let url = ''
            if (this.sid == 51) {
                url = `/activity/2023winter/chinesePreview/51/${item.paper_id}`
            } else {
                url = `/preview/task/21/${item.paper_id}/2023winternew`
            }
            this.$router.push(url)
        }
    }
}
</script>

<style lang="scss" scoped>
.preview-page {
    background: #9c0300;
    min-height: 100vh;
}
.herder {
    height: 96px / $ppr;
    line-height: 96px / $ppr;
    background: #ffffff;
    .back {
        width: 64px / $ppr;
        height: 96px / $ppr;
        display: inline-block;
        position: absolute;
        text-align: center;
        top: 0;
        left: 0;
        z-index: 3;
        i {
            width: 16px / $ppr;
            height: 30px / $ppr;
            background: url("./img/icon_img_23.png") no-repeat;
            background-size: 100% 100%;
            display: inline-block;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }
    p {
        width: 100%;
        text-align: center;
        height: 90px / $ppr;
        display: inline-block;
        font-size: 36px / $ppr;
        color: #333333;
    }
}
.main {
    padding: 50px / $ppr 24px / $ppr 40px / $ppr;
    .item {
        background: url("./img/unit_center.png") repeat-y;
        background-size: 100% 100%;
        padding: 43px / $ppr 22px / $ppr;
        color: #ffe2b7;
        position: relative;
        margin-bottom: 40px / $ppr;
        &:before,
        &:after {
            content: "";
            display: block;
            width: 100%;
            height: 60px / $ppr;
            position: absolute;
            left: 0;
        }
        &:before {
            content: "";
            background: #9c0300 url("./img/unit_top.png") no-repeat;
            background-size: 100% 100%;
            top: 0;
        }
        &:after {
            content: "";
            background: #9c0300 url("./img/unit_bottom.png") no-repeat;
            background-size: 100% 100%;
            bottom: 0;
        }
        .title {
            width: 596px / $ppr;
            margin: 0 auto 50px / $ppr;
            padding: 17px / $ppr 0;
            background: url("./img/unit-bg.png") repeat-y;
            background-size: 100% 100%;
            font-size: 30px / $ppr;
            color: #a90514;
            text-align: center;
            font-family: 宋体;
            font-weight: 900;
            position: relative;
        }
        ul {
            position: relative;
            z-index: 2;
            margin-left: -7.833333%;
            li {
                width: 25.5%;
                margin-left: 7.833333%;
                margin-bottom: 40px / $ppr;
                float: left;
                position: relative;
                background: #ffba7e;
                border-radius: 10px / $ppr;
                padding: 6px / $ppr;
                position: relative;
                overflow: hidden;
                box-sizing: border-box;
                .paper-name {
                    display: block;
                    background: #ffe7c2;
                    font-size: 30px / $ppr;
                    color: #f21500;
                    text-align: center;
                    line-height: 84px / $ppr;
                }
                &:before,
                &:after,
                & > .paper-name:before,
                & > .paper-name:after {
                    content: "";
                    display: block;
                    width: 10px / $ppr;
                    height: 10px / $ppr;
                    background: #ffba7e;
                    border-radius: 10px / $ppr;
                    position: absolute;
                }
                &:before {
                    top: 3px / $ppr;
                    left: 3px / $ppr;
                }
                &:after {
                    top: 3px / $ppr;
                    right: 3px / $ppr;
                }
                & > .paper-name:before {
                    bottom: 3px / $ppr;
                    left: 3px / $ppr;
                }
                & > .paper-name:after {
                    bottom: 3px / $ppr;
                    right: 3px / $ppr;
                }
            }
        }
    }
}
</style>